import { useEffect } from "react";
import { SnackbarAction, SnackbarKey, useSnackbar as useSnackbarStack } from "notistack";
import { IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { EventBusUtils } from "@/utils";
import { EventConstant } from "@/const";

export type SnackbarVariantType = "default" | "error" | "success" | "warning" | "info";

export type SnackbarType = {
  message: string;
  variant: SnackbarVariantType;
};

export const useHandleSnackbar = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbarStack();

  const action: SnackbarAction = (snackbarKey: SnackbarKey) => (
    <IconButton onClick={() => closeSnackbar(snackbarKey)} size="small">
      <Close fontSize="small" htmlColor="#ddd" />
    </IconButton>
  );

  const handleOpenSnackbar = ({ message, variant }: SnackbarType) => {
    enqueueSnackbar(message, {
      variant,
      action,
    });
  };

  useEffect(() => {
    EventBusUtils.on(EventConstant.GLOBAL_EVENTS.openSnackbar, handleOpenSnackbar);

    return () => {
      EventBusUtils.off(EventConstant.GLOBAL_EVENTS.openSnackbar, handleOpenSnackbar);
    };
  });
};

export const useSnackbar = () => {
  const openSnackbar = (message: string, variant: SnackbarVariantType) => {
    EventBusUtils.emit<SnackbarType>(EventConstant.GLOBAL_EVENTS.openSnackbar, {
      message,
      variant,
    });
  };

  return {
    openSnackbar,
  };
};
